import HomePage from '../components/HomePage'
import NotificationPage from '../components/NotificationPage'
import TripsPage from '../components/TripsPage'
import TripPage from '../components/TripPage'
import ContentPage from '../components/ContentPage'
import LoginPage from '../components/LoginPage'
import RegisterPage from '../components/RegisterPage'
import ProfilePage from '../components/ProfilePage'
import ChangePassword from '../components/ChangePassword'
import ResetPassword from '../components/ResetPassword'

export default {
    routes: [
        {
            name: 'login',
            path: '/login',
            component: LoginPage,
        },
        {
            name: 'register',
            path: '/register',
            component: RegisterPage,
        },
        {
            name: 'profile',
            path: '/profile',
            component: ProfilePage,
        },
        {
            name: 'change-password',
            path: '/change-password',
            component: ChangePassword,
        },
        {
            name: 'reset-password',
            path: '/reset-password',
            component: ResetPassword,
        },
        {
            name: 'home',
            path: '/',
            component: HomePage,
        },
        {
            name: 'trips',
            path: '/trips',
            component: TripsPage,
        },
        {
            name: 'trip',
            path: '/trip/:id',
            component: TripPage,
        },
        {
            name: 'notifications',
            path: '/notifications',
            component: NotificationPage,
        },
        {
            name: 'page',
            path: '/page/:id',
            component: ContentPage,
        },
    ]
}



// WEBPACK FOOTER //
// ./src/config/routes.js